export class VigenciaI{
    anio : number;
    salarioMinimo : number;
}